<template>
    <main>
        <div class="box">
            <div class="mark" @click="hideVideo"></div>
            <div class="content">
                <div class="title-box">
                    <div class="element left title">{{video_info.category_title}}<span></span></div>
                    <div class="right close" @click="hideVideo"></div>
                </div>
                <div class="video-box">
                    <video controls preload="auto" id="video_float" loop>
                        <source :src="util.autoImage(video_info.video)" >
                    </video>
                    <div class="mark" v-if="video_play_show">
                        <div class="play" @click="playVideo"></div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'video-float',
        data() {
            return {
                video_play_show:true,
            }
        },
        props:{
            video_info:{
                type:Object,
                default:{},
            }
        },
        components:{

        },
        computed:{

        },
        methods: {
            playVideo(){
                var video = document.getElementById('video_float');
                video.addEventListener('play',()=>{
                    this.video_play_show = false;
                })
                video.addEventListener('pause',()=>{
                    this.video_play_show = true;
                })
                video.play();
            },
            hideVideo(){
                this.$emit('hideVideo')
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.$nextTick(()=>{
                this.playVideo();
            })
        },
        destroyed() {

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{width:750px;height:481px;background:#000;position:absolute;top:50%;left:50%;margin-left: -375px;margin-top: -240px; border-radius: 10px;
            .title-box{height:60px;overflow: hidden;background: #011424;color: #fff;padding: 0 25px;
                .title{width: 600px; font-size: 18px;line-height: 18px; padding-left: 6px;border-left:4px solid #3176c8;height:18px;margin-top: 21px;}
                .close{width: 60px;height:60px;background: url("~@/assets/image/53.png") no-repeat right center;background-size: 20px;cursor: pointer;}
            }
            .video-box{width: 750px;height:421px;position: relative;
                video{width: 100%;height:100%;object-fit: cover;outline: none;}
                .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.5);
                    .play{width: 85px;height:85px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/4.png") no-repeat left center;background-size: contain;margin-left: -42px;margin-top: -42px; cursor: pointer;border-radius: 50%;}
                }
            }
        }
    }
</style>

